// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'walkie-solid';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M11.5 1v2m-7 4v2' />
    <path
      fill='currentColor'
      d='M11 3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zM7 13.6a.9.9 0 0 0 0 1.8h4a.9.9 0 0 0 0-1.8zm0-2a.9.9 0 0 0 0 1.8h4a.9.9 0 0 0 0-1.8zm1-7.1A1.5 1.5 0 0 0 6.5 6v2A1.5 1.5 0 0 0 8 9.5h2A1.5 1.5 0 0 0 11.5 8V6A1.5 1.5 0 0 0 10 4.5z'
    />
  </g>
);

export const viewBox = '0 0 18 18';
